<template>
  <div>
    <h1>Cash Register</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>